import { ServiceNameLabels, ServiceNameTypeLabels } from '@consigli/types';

const serviceCodeToNameMap: Record<string, string> = {
  ...ServiceNameLabels,
  ...ServiceNameTypeLabels,
};

export const mapServiceCodeToName = (serviceCode: string) => {
  return serviceCodeToNameMap[serviceCode] ?? serviceCode;
};
